import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import AppManager from "../../managers/AppManager";
import Utility from "../../utility/Utility";
import LandingPageService from "../../services/landingPage";
import React from "react";
import LandingPageHeader from "./LandingPageHeader";
import TemplateManager from "./templates/TemplateManager";

import template_1 from "../../assets/email_template/INQUIRY_POSITION.png";
import template_2 from "../../assets/email_template/ACK_RECEPT_APPLICATION.png";
import template_3 from "../../assets/email_template/CANDIDATE_CONSIDER.png";
import template_4 from "../../assets/email_template/POSISTION_FILL.png";
import template_5 from "../../assets/email_template/POSSIBLE_CONSIDERATION.png";
import template_6 from "../../assets/email_template/REJECT.png";

import { showToast, TOAST_TYPE } from "deskera-ui-library";

export default class LandingPageManager {
  static pageData;
  static directLink = null;
  static selectedTemplateId = null;

  static status = {
    ACTIVE: [1],
    IN_ACTIVE: [2],
  };

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getAllCreationSteps() {
    const pageId = LandingPageManager.getPageRecordId()
      ? "/" + LandingPageManager.getPageRecordId()
      : "";
    return [
      {
        title: LandingPageManager.isPageDataAvailable()
          ? "Change Template"
          : "Select Template",
        onClick: () => {
          RouteManager.navigateToPage(
            PAGE_ROUTES.SELECT_LANDING_PAGE_TEMPLATE + pageId
          );
        },
      },
      {
        title: LandingPageManager.isPageDataAvailable()
          ? "Edit Design"
          : "Design",
        onClick: () => {
          if (LandingPageManager.isPageDataAvailable()) {
            RouteManager.navigateToPage(
              PAGE_ROUTES.LANDING_PAGE_BUILDER + pageId
            );
          } else {
            showToast("Please select template", TOAST_TYPE.FAILURE);
          }
        },
      },
      {
        title: LandingPageManager.isPageDataAvailable()
          ? "Publish Details"
          : "Publish",
        onClick: () => {
          if (LandingPageManager.isPageDataAvailable()) {
            RouteManager.navigateToPage(
              PAGE_ROUTES.LANDING_PAGE_DOMAIN + pageId
            );
          } else {
            showToast("Please save your design", TOAST_TYPE.FAILURE);
          }
        },
      },
    ];
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static isPageDataAvailable() {
    return !(
      LandingPageManager.pageData === null ||
      LandingPageManager.pageData === undefined
    );
  }

  static setPageData(response) {
    LandingPageManager.pageData = response;
  }

  static getPageData() {
    return LandingPageManager.pageData;
  }

  ////////////////////////////////////////////////////////////////////////////////////

  static getPageRecordId() {
    if (!LandingPageManager.isPageDataAvailable()) {
      return null;
    }

    return LandingPageManager.pageData.data._id;
  }
  ////////////////////////////////////////////////////////////////////////////////////

  static getDirectLink() {
    if (!LandingPageManager.isPageDataAvailable()) {
      return "URL not found";
    }

    let directLink =
      LandingPageManager.pageData.data.cells[
        LandingPageManager.getColumnId(COLUMN_CODE.LANDING_PAGE.DIRECT_LINK)
      ];
    return AppManager.generateDirectLink(directLink);
  }

  static getPageStatus() {
    if (!LandingPageManager.isPageDataAvailable()) {
      return false;
    }

    let status =
      LandingPageManager.pageData.data.cells[
        LandingPageManager.getColumnId(COLUMN_CODE.LANDING_PAGE.STATUS)
      ];

    status = JSON.stringify(status);

    return status === "[1]";
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getPageJSONData() {
    if (!LandingPageManager.isPageDataAvailable()) {
      return [];
    }

    let jsonData =
      LandingPageManager.pageData.data.cells[
        LandingPageManager.getColumnId(COLUMN_CODE.LANDING_PAGE.JSON_DATA)
      ];

    return Utility.decodeJSON(jsonData);
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getRequestToSavePage(pageData) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.NAME)] = pageData.name;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.VISITORS)] = 0;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.HTML_DATA)] = pageData.html;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.JSON_DATA)] = pageData.json;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.HASH)] = pageData.hash;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.STATUS)] =
      LandingPageManager.status.ACTIVE;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.PUBLISHED)] = true;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.CUSTOM_DOMAIN)] =
      pageData.domain;
    return data;
  }

  static getRequestToUpdatePage(pageData) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.HTML_DATA)] = pageData.html;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.JSON_DATA)] = pageData.json;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.PUBLISHED)] = true;
    return data;
  }

  static getRequestToUpdateStatus(isActive) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.STATUS)] =
      isActive === true
        ? LandingPageManager.status.ACTIVE
        : LandingPageManager.status.IN_ACTIVE;
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.PUBLISHED)] = true;
    return data;
  }

  static getRequestToUpdateDomain(pageData) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.LANDING_PAGE.CUSTOM_DOMAIN)] =
      pageData.domain;
    return data;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getColumnId(columnCode) {
    return TableManger.getColumnId(TABLES.PEOPLE_EMAIL_TEMPLATE, columnCode);
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static fetchPageDataById(id, callback) {
    LandingPageService.getData(
      id,
      (response) => {
        LandingPageManager.setPageData({ data: response });
        callback && callback();
      },
      (error) => {}
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getHeader() {
    return (
      <LandingPageHeader title={"Email Templates"} stepperIndex={0} />
    );
  }

  static navigateToBuilder() {
    RouteManager.navigateToPage(PAGE_ROUTES.LANDING_PAGE_BUILDER);
  }

  static setSelectedTemplateId(id) {
    TemplateManager.setSelectedTemplateId(id);
  }

  static getAllTemplates() {
    return [
      template_1,
      template_2,
      template_3,
      template_4,
      template_5,
      template_6
    ];
  }

  static getSelectedTemplateId() {
    return TemplateManager.getSelectedTemplateId();
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
}
